module.exports = __webpack_public_path__ + "img/notifications.9038b489.svg";